// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA3J99G_cDre209pcrhmo4uVRsI0GOADRs",
  authDomain: "guest-artist-showcase-2024.firebaseapp.com",
  projectId: "guest-artist-showcase-2024",
  storageBucket: "guest-artist-showcase-2024.appspot.com",
  messagingSenderId: "791105697803",
  appId: "1:791105697803:web:ebd2d4e5258ba03566af0e",
  measurementId: "G-33Q1VQQ2GQ",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const messaging = getMessaging(app);
export const analytics = getAnalytics(app);
